import { createContext, useContext } from 'react'
import type { RailSection } from '@/components/layout/founderNavConfig'

interface MobileSidebarContextValue {
  mobileOpen: boolean
  setMobileOpen: (open: boolean) => void
  // While set, the sidebar shows this rail section instead of the one derived
  // from the current pathname. Lets a rail tap preview a section's submenu on
  // mobile before committing to a route.
  previewSection: RailSection | null
  setPreviewSection: (section: RailSection | null) => void
}

const MobileSidebarContext = createContext<MobileSidebarContextValue>({
  mobileOpen: false,
  setMobileOpen: () => {},
  previewSection: null,
  setPreviewSection: () => {},
})

export const useMobileSidebar = () => useContext(MobileSidebarContext)
export { MobileSidebarContext }
